import { useTranslation } from 'react-i18next'

import Text from '../../../../Text'
import { CreatePasswordFormRequirementsItem } from '../CreatePasswordFormRequirementsItem'

import { CREATE_PASSWORD_FORM_REQUIREMENTS_ITEMS } from './CreatePasswordFormRequirements.constants'

import * as styles from './CreatePasswordFormRequirements.module.css'

function CreatePasswordFormRequirements({
  className = styles.CreatePasswordFormRequirements,
  itemClassName,
  items = CREATE_PASSWORD_FORM_REQUIREMENTS_ITEMS,
  listClassName = styles.list,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <Text>{t('Auth.CreatePasswordRequirementsTitleKey')}</Text>
      <div className={listClassName}>
        {items.map((item, index) => (
          <CreatePasswordFormRequirementsItem
            className={itemClassName}
            key={index}
            text={t(item)}
          />
        ))}
      </div>
    </div>
  )
}

export default CreatePasswordFormRequirements
